module.exports = __webpack_public_path__ + "img/Support-skill-506.94515eba.png";